import { HStack, Icon } from "@/shared/ui/primitives";
import { useTranslation } from "react-i18next";

export interface WorkflowHeaderProps {
	selected: string;
	onToggleDropdown?: () => void;
}

export const WorkflowHeader = (p: WorkflowHeaderProps) => {
	const { t } = useTranslation();

	return (
		<HStack className="w-full px-[20px] py-[16px] rounded-[20px] border border-outline bg-bg-weak/80 text-ct-regular font-medium backdrop-blur-sm shadow-[0_8px_32px_rgba(15,23,42,0.06)]">
			<span className="w-full text-lg text-ct-strong">{p.selected}</span>
			<button onClick={p.onToggleDropdown}>
				<HStack className="h-[36px] pl-[6px] pr-[12px] rounded-[10px] gap-[4px] bg-bg-regular text-sm font-medium text-ct-regular shrink-0">
					<Icon name="Down" />
					<span>{t("common.more")}</span>
				</HStack>
			</button>
		</HStack>
	);
};
